(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rgh-cart-progress-widget"] && !Shopify.designMode) return;
  try {
    (function () {
    function refreshWidget(widget) {
      var sectionId = widget.dataset.sectionId;
      if (!sectionId) return;

      var url =
        window.location.pathname +
        (window.location.search ? window.location.search + '&' : '?') +
        'section_id=' +
        sectionId;

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (responseText) {
          var html = new DOMParser().parseFromString(responseText, 'text/html');
          var source = html.querySelector('[data-rgh-cart-progress][data-section-id="' + sectionId + '"]');
          if (source) widget.replaceWith(source);
        })
        .catch(function (e) {
          console.error(e);
        });
    }

    function refreshAll() {
      document.querySelectorAll('[data-rgh-cart-progress]').forEach(refreshWidget);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshAll);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rgh-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    const EMOJI_RE =
      /[\u{1F1E6}-\u{1F1FF}\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{2190}-\u{21FF}\u{2B00}-\u{2BFF}\u{FE0F}\u{200D}]/gu;

    function sanitizeDesc(card) {
      const el = card.querySelector('[data-rgh-desc]');
      if (!el) return;
      const cleaned = el.textContent.replace(EMOJI_RE, '').replace(/\s+/g, ' ').trim();
      if (cleaned !== el.textContent) el.textContent = cleaned;
    }

    function initCard(card) {
      if (card._rghInit) return;
      card._rghInit = true;

      sanitizeDesc(card);

      const qtyVal = card.querySelector('[data-rgh-qty-val]');
      const decBtn = card.querySelector('[data-rgh-qty-dec]');
      const incBtn = card.querySelector('[data-rgh-qty-inc]');
      const addBtn = card.querySelector('[data-rgh-add-to-cart]');

      let qty = 1;

      if (decBtn) {
        decBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (qty > 1) {
            qty--;
            if (qtyVal) qtyVal.textContent = qty;
          }
        });
      }
      if (incBtn) {
        incBtn.addEventListener('click', function (e) {
          e.preventDefault();
          qty++;
          if (qtyVal) qtyVal.textContent = qty;
        });
      }

      if (addBtn) {
        addBtn.addEventListener('click', async function (e) {
          e.preventDefault();
          const variantId = addBtn.dataset.variantId;
          if (!variantId || addBtn.disabled) return;

          addBtn.disabled = true;

          const cartNotification = document.querySelector('cart-notification');

          try {
            const body = { id: parseInt(variantId), quantity: qty };
            if (cartNotification) {
              body.sections = cartNotification.getSectionsToRender().map(function (section) {
                return section.id;
              });
              body.sections_url = window.location.pathname;
            }

            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify(body),
            });
            if (!res.ok) throw new Error('Cart error');
            const addResponse = await res.json();

            const cartRes = await fetch('/cart.js');
            const cartData = await cartRes.json();

            // Notify Dawn's cart-update subscribers (e.g. <cart-items> on the
            // cart page) so they re-render without a full page reload.
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rgh-product-card', cartData: cartData });
            }

            document
              .querySelectorAll('.cart-count-bubble span:first-child, .header__cart-count')
              .forEach(function (b) {
                b.textContent = cartData.item_count;
              });

            if (cartNotification) cartNotification.renderContents(addResponse);

            addBtn.classList.add('is-added');
            setTimeout(function () {
              addBtn.classList.remove('is-added');
            }, 1400);
          } catch (err) {
            // ignore: button simply re-enables below without the success animation
          }

          addBtn.disabled = false;
        });
      }
    }

    function initAllCards() {
      document.querySelectorAll('.rgh-pcard').forEach(initCard);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllCards);
    } else {
      initAllCards();
    }

    // Cards frequently get swapped in after page load via innerHTML
    // replacement rather than DOM insertion - Dawn's facets.js on collection
    // filter/sort, and the <product-recommendations> custom element (related
    // products, cart cross-sell, complementary products) on scroll-into-view.
    // Neither preserves listeners since these cards aren't custom elements,
    // so watch the whole document and re-init any newly-inserted cards.
    if (window.MutationObserver) {
      new MutationObserver(initAllCards).observe(document.body, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rgh-product-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function initDrag(container) {
      var isDown = false;
      var startX;
      var scrollLeft;
      var moved = false;

      // Touch already scrolls this element natively via overflow-x: auto;
      // only mouse pointers need the manual drag-to-scroll behavior below,
      // otherwise the two would fight over scrollLeft during a touch drag.
      container.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isDown = true;
        moved = false;
        startX = e.clientX;
        scrollLeft = container.scrollLeft;
        container.classList.add('is-dragging');
      });

      container.addEventListener('pointermove', function (e) {
        if (!isDown || e.pointerType !== 'mouse') return;
        var x = e.clientX;
        var walk = startX - x;
        if (Math.abs(walk) > 3) moved = true;
        container.scrollLeft = scrollLeft + walk;
      });

      container.addEventListener(
        'click',
        function (e) {
          if (moved) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        },
        true
      );

      function endDrag(e) {
        if (!isDown) return;
        isDown = false;
        container.classList.remove('is-dragging');
        moved = false;
      }

      container.addEventListener('pointerup', endDrag);
      container.addEventListener('pointercancel', endDrag);
      container.addEventListener('pointerleave', function (e) {
        if (isDown) endDrag(e);
      });
    }

    function initAll() {
      var containers = document.querySelectorAll('.rgh-product-grid__carousel .rgh-product-grid__items');
      containers.forEach(function (c) {
        initDrag(c);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
  })();

  document.querySelectorAll('[data-rgh-product-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('.rgh-product-grid__items');
    const prev = carousel.querySelector('[data-rgh-product-carousel-prev]');
    const next = carousel.querySelector('[data-rgh-product-carousel-next]');

    if (!track || !prev || !next) return;

    const AUTOPLAY_MS = 3500;
    const noMobileAutoplay = carousel.hasAttribute('data-rgh-product-carousel-no-mobile-autoplay');
    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
    let timer = null;
    let userScrolling = false;

    const getPageScroll = () => {
      const card = track.querySelector('.rgh-product-grid__slide');
      const cardW = card ? card.offsetWidth : track.clientWidth / 2;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return (cardW + gap) * 2;
    };

    const atEnd = () => track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;

    const advance = () => {
      if (atEnd()) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: getPageScroll(), behavior: 'smooth' });
      }
    };

    const startAutoplay = () => {
      if (timer) return;
      if (noMobileAutoplay && isMobile()) return;
      timer = setInterval(advance, AUTOPLAY_MS);
    };

    const stopAutoplay = () => {
      clearInterval(timer);
      timer = null;
    };

    const updateButtons = () => {
      const maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= maxScroll;
    };

    prev.addEventListener('click', () => {
      stopAutoplay();
      if (track.scrollLeft <= 1) {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: -getPageScroll(), behavior: 'smooth' });
      }
      startAutoplay();
    });

    next.addEventListener('click', () => {
      stopAutoplay();
      advance();
      startAutoplay();
    });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    track.addEventListener(
      'touchstart',
      () => {
        userScrolling = true;
        stopAutoplay();
      },
      { passive: true }
    );
    track.addEventListener(
      'touchend',
      () => {
        userScrolling = false;
        startAutoplay();
      },
      { passive: true }
    );

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    updateButtons();
    startAutoplay();
  });
  } catch(e) { console.error(e); }
})();

})();
